const Watermark = () => {
  return (
    <a
      target="_blank"
      href="https://github.com/devugo"
      rel="noreferrer"
      className="devugo-watermark"
    >
      <span>
        Developed by <b>devugo</b>
      </span>
    </a>
  );
};
export default Watermark;
